import AgentAnnouncementLinkDTO from "./AgentAnnouncementLinkDTO";

export default class AgentAnnouncementDTO {

  constructor(jsonResponse) {
    this.id = jsonResponse["id"];
    this.creatingUserId = jsonResponse["creating-user-id"];
    this.categoryId = jsonResponse["category-id"];
    this.title = jsonResponse["title"];
    this.description = jsonResponse["description"];
    this.dateCreated = jsonResponse["date-created"];
    this.active = jsonResponse["active"];
    let links = [];
    jsonResponse["links"].forEach(link => {
      links.push(new AgentAnnouncementLinkDTO.toJson(link));
    })
    this.links = links;
  }

  static toJson = function (obj) {
    let jsonObj = {};
    jsonObj["id"] = obj.id;
    jsonObj["creatingUserId"] = obj.creatingUserId;
    jsonObj["categoryId"] = obj.categoryId;
    jsonObj["dateCreated"] = obj.dateCreated;
    jsonObj["title"] = obj.title;
    jsonObj["description"] = obj.description;
    jsonObj["active"] = obj.active;
    jsonObj["links"] = obj.links;
    return jsonObj;
  }
}
